$(document).on('submit', '.feedback .feedbackForm', function(e) {
    e.preventDefault();
    $(this).addClass('loading-form');
    
    var form = $(this);
    var formmessage = form.find('#message').val().trim();
    var isValid = true;

    // Kontrola, zda je pole vyplněné
    if (formmessage === '') {
        isValid = false;
        showMessage('Váš názor je nevyplněný. Vyplňte ho prosím a pak odešlete', 'error', '', false, true);
    }

    if (!isValid) {
        form.removeClass('loading-form');
        return;
    }

    // Vytvoření FormData
    var formdata = new FormData();
    formdata.append("message", formmessage);

    // Odeslání dat pomocí fetch
    fetch("https://tools.shopcode.cz/e-mail_sender/fishinghouse/www/", {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    })
    .then(response => response.json())
    .then(function(result) {
        if (result.status === 'ok') {
            showMessage('Názor byl úspěšně odeslán, děkujeme za zpětnou vazbu.', 'success', '', false, true);
            form[0].reset(); // Vymazání formuláře po úspěchu
        } else {
            showMessage('Při odeslání nastala chyba: ' + (result.message || 'Neznámá chyba.'), 'error', '', false, true);
        }
        form.removeClass('loading-form');
    })
    .catch(function(error) {
        console.error('Error:', error);
        showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
        form.removeClass('loading-form');
    });
});
